<template>
  <div class="resPortfolioSection" style="margin-bottom:140px; margin-top:-50px; cursor: pointer;">
    <div v-for="(image, i) in images" @click="index = i" :key="i">
      <div v-if="i < 3">
        <img v-if="i === 0" style="width:100%; height:201px;object-fit: cover" :src="image" />
        <div v-else-if="i !== 0">
          <img v-if="i % 2 === 0" style="width:50%; height:140px; float:right;" :src="image" />
          <img v-else style="width:50%; height:140px; float:left" :src="image" />
        </div>
      </div>
    </div>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
/* eslint-disable */
import gallery from "../../shared/gallerySlideShow";
export default {
  components: {
    gallery
  },
  props: {
    images: {}
  },
  data() {
    return {
      index: null
    };
  }
};
</script>

<style lang="scss" scoped></style>
